module.exports = __webpack_public_path__ + "img/product_w.16dda343.svg";